import React from 'react'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import ogImage from 'src/images/ogp.png'
import BaseUrl from 'src/components/shared/BaseUrl.js'

type Props = {
  title: string
  description?: string
  lang?: string
  meta?: Array<MetaProps>
  keywords?: Array<string>
  top?: boolean
  image?: string
  noIndex?: boolean
}

type MetaProps = {
  name: string
  content: string
}

const SEO = ({
  title,
  description,
  lang,
  meta,
  keywords,
  top,
  image,
  noIndex
}: Props) => {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description

        const pageTitle = top
          ? data.site.siteMetadata.title
          : `${title} | ${data.site.siteMetadata.title}`

        const pageLang = lang || `ja`

        const metaImage = image || ogImage

        const isIndex = noIndex ? 'noindex' : 'index'

        const origin =
          typeof window !== 'undefined' ? window.location.origin : BaseUrl
        const url =
          typeof window !== 'undefined' ? window.location.href : BaseUrl

        return (
          <Helmet
            htmlAttributes={{ lang: pageLang }}
            title={pageTitle}
            meta={[
              {
                name: `title`,
                content: data.site.siteMetadata.title
              },
              {
                name: `description`,
                content: metaDescription
              },
              {
                name: `robots`,
                content: isIndex
              },
              {
                property: `og:type`,
                content: `website`
              },
              {
                property: `og:url`,
                content: url
              },
              {
                property: `og:title`,
                content: pageTitle
              },
              {
                property: `og:description`,
                content: metaDescription
              },
              {
                property: 'og:image',
                content: origin + metaImage
              },

              {
                name: `twitter:card`,
                content: `summary_large_image`
              },
              {
                property: `twitter:url`,
                content: url
              },
              {
                name: `twitter:title`,
                content: pageTitle
              },
              {
                name: `twitter:description`,
                content: metaDescription
              },
              {
                property: 'twitter:image',
                content: origin + metaImage
              },
              {
                name: 'google-site-verification',
                content: 'vL5ULe-s17U-HqDXN9lbJ4AU7W4tJTx3JNglPKpI_S0'
              },
              {
                name: 'facebook-domain-verification',
                content: 'z1kagppb5e95h9dxelhgmj7ootgi7i'
              }
            ]
              .concat(
                keywords && keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `)
                    }
                  : []
              )
              .concat(meta && meta.length > 0 ? meta : [])}
          >
            {/* <script src="https://identity.netlify.com/v1/netlify-identity-widget.js" />
            // zendeskのチャット埋め込みスクリプト
            <script
              id="ze-snippet"
              src="https://static.zdassets.com/ekr/snippet.js?key=23ada4f1-39b6-45b1-b190-d77293c5e705"
            /> */}
          </Helmet>
        )
      }}
    />
  )
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
